import { API_TYPES } from "@src/appV2/api/constants";
import { z } from "zod";

const ChartingNoncomplianceDataTypeSchema = z.literal(API_TYPES.chartingNoncompliance);
const ChartingNoncomplianceAttributesSchema = z.object({
  modalContent: z.object({
    preDeactivationHeader: z.string(),
    preDeactivationSubtext: z.string(),
    deactivatedHeader: z.string(),
    deactivatedSubtext: z.string(),
  }),
  deadlineToChart: z.string().datetime(),
  deadlineToReview: z.string().datetime().optional(),
  chartingVerifiedAt: z.string().datetime().optional(),
  incompleteChartingNotes: z.string().optional(),
  chartingStatus: z.enum(["not_started", "partially_completed", "completed"]).optional(),
  completionPercentage: z.number().optional(),
});

const ChartingNoncomplianceWorkplaceRelationshipSchema = z.object({
  data: z.object({
    type: z.literal(API_TYPES.workplace),
    id: z.string(),
  }),
});

const ChartingNoncomplianceWorkerRelationshipSchema = z.object({
  data: z.object({
    type: z.literal(API_TYPES.worker),
    id: z.string(),
  }),
});

const ChartingNoncomplianceShiftRelationshipSchema = z.object({
  data: z.object({
    type: z.literal(API_TYPES.shift),
    id: z.string(),
  }),
});

const ChartingNoncomplianceRelationshipsSchema = z.object({
  workplace: ChartingNoncomplianceWorkplaceRelationshipSchema,
  worker: ChartingNoncomplianceWorkerRelationshipSchema,
  shift: ChartingNoncomplianceShiftRelationshipSchema,
});

const ChartingNoncomplianceDataSchema = z.object({
  type: ChartingNoncomplianceDataTypeSchema,
  id: z.string(),
  attributes: ChartingNoncomplianceAttributesSchema,
  relationships: ChartingNoncomplianceRelationshipsSchema,
});

const ChartingNoncompliancesDataSchema = z.array(ChartingNoncomplianceDataSchema);

export const GetChartingNoncompliancesResponseSchema = z.object({
  data: ChartingNoncompliancesDataSchema,
});

export type GetChartingNoncompliancesResponse = z.infer<
  typeof GetChartingNoncompliancesResponseSchema
>;

export type ChartingNoncompliance = z.infer<typeof ChartingNoncomplianceDataSchema>;

export const PatchChartingNoncomplianceRequestSchema = z.object({
  data: z.object({
    type: ChartingNoncomplianceDataTypeSchema,
    id: z.string(),
    attributes: z.object({
      deadlineToReview: z.coerce.date().optional(),
    }),
  }),
});

export type PatchChartingNoncomplianceRequest = z.infer<
  typeof PatchChartingNoncomplianceRequestSchema
>;

export const PatchChartingNoncomplianceResponseSchema = z.object({
  data: ChartingNoncomplianceDataSchema,
});

export type PatchChartingNoncomplianceResponse = z.infer<
  typeof PatchChartingNoncomplianceResponseSchema
>;

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ChartingNoncomplianceStateSchema = z.enum([
  "recalled",
  "review",
  "violation",
  "verified",
  "auto_verified",
  "reported_incomplete",
  "expired",
]);

export type ChartingNoncomplianceState = z.infer<typeof ChartingNoncomplianceStateSchema>;
